<template>
	<v-tabs model="tab" right class="pa-2">
		<v-tab href="#task">
			Task<v-icon>mdi-format-list-checks</v-icon>
		</v-tab>
		<v-tab href="#notes" v-if="editing">
			Notes<v-icon>mdi-notebook</v-icon>
		</v-tab>
		<v-tab-item value="task">
			<v-form id="newTaskForm" class="pa-5" ref="form">
				<v-row>
					<v-col>
						<v-text-field v-model="title" label="Task Title"></v-text-field>
						<v-textarea
							v-model="text"
							label="Description"
						></v-textarea>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-row class="pl-3">
							<v-checkbox v-model="view" value="admin" label="Admin" class="mr-3"></v-checkbox>
							<v-checkbox v-model="view" value="client" label="Client" class="mr-3"></v-checkbox>
							<v-checkbox v-model="view" value="panelist" label="Panelist" class="mr-3"></v-checkbox>
							<v-checkbox v-model="view" value="visitor" label="Visitor" class="mr-3"></v-checkbox>
						</v-row>
					</v-col>
					<v-col class="pt-5">
						<span class="v-label theme--light">Priority: </span>
						<v-btn-toggle v-model="priority">
							<v-btn value="normal" color="primary" text>Normal</v-btn>
							<v-btn value="high" color="red" text>High</v-btn>
						</v-btn-toggle>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-select label="Status" v-model="status" :items="statuses"></v-select>	
						<v-select label="Assigned To" v-model="assignedTo" :items="admins" item-value="id" item-text="displayName"></v-select>		
					</v-col>
				</v-row>
				<v-btn v-if="editing" color="error" dark class="mr-4" @click="deleteTask"> Delete Task </v-btn>
				<v-btn color="primary" dark class="mr-4" @click="reset"> Reset Form	</v-btn>
				<v-btn :disabled="!valid" color="success" class="mr-4" @click="saveTask"> Save Task	</v-btn>
			</v-form>
		</v-tab-item>
		<v-tab-item value="notes">
			<EditObjectNotes :object="object" v-on:save="saveTask"></EditObjectNotes>
		</v-tab-item>
	</v-tabs>
</template>

<script>
	import Vuex from "vuex"
	import EditObjectNotes from "../edits/EditObjectNotes.vue"
	export default {
		name: 'TaskForm',
		data: () => ({
			valid: true,
			title: '',
			status: 'new',
			text: '',
			priority: 'normal', 
			assignedTo: false,
			view: [],
			notes: [],
			tab: "task"
		}),
		props: ["editing"],
		computed: {
			...Vuex.mapState( {
				statuses: state => state.settings.taskStatuses,
				admins: state => state.admin.admins,
			}), 
			object(){
				if( !this.editing ){
					return false;
				}
				return {
					notes: this.notes, 
					id: this.id
				}
			}
		},
		components: {
			EditObjectNotes: EditObjectNotes
		},
		watch: {
			editing: {
				immediate: true,
				handler(){				
					if( this.editing ){
						if( !this.editing.notes ){
							this.editing.notes = [];
						}
						for( var key in this.editing ){
							this[key] = this.editing[key]
						}
					}
					else{
						this.$refs.form.reset();
					}
				}
			}
		},
		methods: {
			deleteTask(){
				var self = this;
				var id = self.editing.id
				self.$store.dispatch( "updateDoc", {
					doc: "tasks/" + id,
					action: "delete",
					data: {}
				} ).then( () => {
					self.$emit("created", id )
				})
			},
			saveTask () {
				var self = this;
				if( !self.editing ){
					let newTask = { 
						title: self.title,
						text: self.text,
						status: self.status,
						assignedTo: self.assignedTo,
						priority: self.priority ? self.priority : "normal",
						view: self.view,
					}
					self.$store.dispatch( "addDoc", {
						collection: "tasks",
						data: newTask
					} ).then( function( ref ){
						self.$refs.form.reset();
						self.$emit("created", ref.id, "task" )
					} );
				}
				else{
					var id = self.editing.id
					let edits = { 
						title: self.title,
						assignedTo: self.assignedTo,
						text: self.text,
						status: self.status,
						priority: self.priority ? self.priority : "normal",
						view: self.view,
						notes: self.notes
					}
					self.$store.dispatch( "updateDoc", {
						doc: "tasks/" + id,
						action: "update",
						data: edits
					} ).then( function(  ){
						self.$refs.form.reset();
						self.$emit("created" )
					} );
				}
			}, 
			reset: function(){
				this.$refs.form.reset();
			}
		}
	};
</script>
